import axios from 'axios'

const preparePayload = (provider, data) => {

  return {
    id: data.webcastId,
    channel: { id: data.channelId },
    status: 'cancelled',
    'provider': {
      'name': provider
    }
  }

}

const sendData = (payload, host) =>
  axios.put(`${host}/service/channel/channel/${payload.channel.id}/webcast/${payload.id}`,
    JSON.stringify(payload),
    {
      headers: {
        'content-type': 'application/json',
        'accept': 'application/json'
      }
    }
  )

const sendWebcastDataCancel = (provider, data, host = '') => {

  const payload = preparePayload(provider, data)
  return sendData(payload, host)

}

export default sendWebcastDataCancel
